import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=7e03675b&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e03675b')) {
      api.createRecord('7e03675b', component.options)
    } else {
      api.reload('7e03675b', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=7e03675b&", function () {
      api.rerender('7e03675b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bS5Yfld3f82Y/JS/comp/IncreaseNumber.vue"
export default component.exports